export default __webpack_public_path__ + "static/media/slide2.874d4a43.jpg";